import { render, staticRenderFns } from "./EndOfTask.vue?vue&type=template&id=8b7807d0&scoped=true&"
import script from "./EndOfTask.vue?vue&type=script&lang=js&"
export * from "./EndOfTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b7807d0",
  null
  
)

export default component.exports